import React from 'react'
import Imagen from './Imagen'
import Card from './Card'
import Marcas from '../data/marcas.json'

const Galeria = (props) => {

    // Declaring variables
    let carros = props.carros

    // Render a screen depending of the @type propiedad
    // This render a image gallery
    if(props.tipo === "imagen") {return (
        <>
            <div className="d-flex justify-content-center align-items-center">
            {Marcas.map((data, id)=>{
                return(
                        <Imagen
                        path = {data.logo}
                        key={id}
                        />
                )
            })}
            </div>
        </>
        )
    }

    // This render a card gallery
    else{ return (
        <>
        <div className="d-flex flex-wrap flex-row mx-4">
        {carros.map((data, id)=>{
            return(
                    <Card
                    picturePath = {data.picturePath}
                    brand = {data.brand}
                    model = {data.model}
                    year = {data.year}
                    descrip = {data.descrip}
                    _id = {data._id}
                    key={id}
                    />
                )
            })}
        </div>
        </>
        )
    }
}

export default Galeria